import { useEffect, useState } from 'react';
import { type MutationStatus, useQueryClient } from '@tanstack/react-query';
import { resolverBridgeQueryKeys } from '../resolver-queries-keys';

export const useCreateResolverJobMutationStatus = () => {
    const [mutationStatus, setMutationStatus] = useState<MutationStatus>('idle');

    const queryClient = useQueryClient();

    useEffect(() => {
        const unsubscribe = queryClient.getMutationCache().subscribe(({ mutation }) => {
            if (mutation) {
                if (mutation.options.mutationKey?.[0] === resolverBridgeQueryKeys.createJob[0]) {
                    const status = mutation.state.status;
                    setMutationStatus(status);
                    if (status === 'error' || status === 'success') {
                        unsubscribe();
                    }
                } else {
                    unsubscribe();
                }
            }
        });
    }, [queryClient]);

    return {
        isLoading: mutationStatus === 'loading',
        isSuccess: mutationStatus === 'success',
        isError: mutationStatus === 'error',
    };
};
